import React from 'react';
import { cn } from '@/lib/utils';
import { Input } from '@predoc/cow';

type IconInputProps = {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
} & React.ComponentProps<typeof Input>;

export const IconInput = ({
  startIcon,
  endIcon,
  className,
  ...props
}: IconInputProps) => {
  return (
    <div className="relative w-full items-center">
      {startIcon && (
        <span className="absolute inset-y-0 start-0 flex items-center justify-center px-2">
          {startIcon}
        </span>
      )}
      <Input
        {...props}
        className={cn(
          'w-full',
          startIcon ? 'pr-2 pl-8' : 'px-2',
          endIcon && 'pr-8',
          className,
        )}
      />
      {endIcon && (
        <span className="absolute inset-y-0 end-0 flex items-center justify-center px-2">
          {endIcon}
        </span>
      )}
    </div>
  );
};
